export const LIVE_MESSAGE_EVENT = 'output:internal:live-journal:message';
export const LIVE_REACTION_EVENT = 'output:internal:live-journal:reaction';
export const JUMP_TO_MESSAGE_EVENT = 'output:jump-to-message';
